/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedIconBubbleEmail_viewer$ref = any;
export type PdpSharedIconBubbleEmail_viewer = {
    readonly isPdpStfEnabled: boolean | null;
    readonly " $refType": PdpSharedIconBubbleEmail_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedIconBubbleEmail_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isPdpStfEnabled",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "enablePdpStf"
                }
            ],
            "storageKey": "isEnabled(key:\"enablePdpStf\")"
        }
    ]
} as any);
(node as any).hash = '16339c274af40e39af6e9fbee97624f0';
export default node;
